export const parsePriceToObject = (data) => {
    return {
        ...data,
    };
};
